import { render, staticRenderFns } from "./ResidentActivityDetail.vue?vue&type=template&id=36b79798&"
import script from "./ResidentActivityDetail.vue?vue&type=script&lang=js&"
export * from "./ResidentActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports